/*

	SHOPCREATIFY SCRIPTS

	1. Page-Specific Scripts
		1.1. Home Page
		1.2. Collection Page
		1.3. Product Page
			1.3.1. Size Calculator
			1.3.2. Tooltips
      1.3.3. Sample labels
      1.3.4. Product Recommendations
		1.4. Blog Index
		1.5. Blog Post
		1.6. Cart Page
			1.6.1. VAT Validation
			1.6.2. Swatch Cards
			1.6.3. EORI Number
		1.7. Account
	2. Components
		2.1. Tabs
		2.2. Tooltips
	3. Utility Functions
	4. Plugins

*/

Shopify.Foldabox = {

	storage: {

		sizes: [
			{
				tag: "A3 Lift Off Lid",
				dimensions: {
					inside_inside_length: 0,
					inside_inside_width: 0,
					inside_inside_height: 0,
					boxsize_inside_length: 0,
					boxsize_inside_width: 0,
					boxsize_inside_height: 0,
				}
			},
			{
				tag: "A3 Deep",
				dimensions: {
					inside_inside_length: 0,
					inside_inside_width: 0,
					inside_inside_height: 0,
					boxsize_inside_length: 0,
					boxsize_inside_width: 0,
					boxsize_inside_height: 0,
				}
			},
			{
				tag: "A3 Shallow",
				dimensions: {
					inside_inside_length: 0,
					inside_inside_width: 0,
					inside_inside_height: 0,
					boxsize_inside_length: 0,
					boxsize_inside_width: 0,
					boxsize_inside_height: 0,
				}
			},
			{
				tag: "A4 Deep",
				dimensions: {
					inside_inside_length: 0,
					inside_inside_width: 0,
					inside_inside_height: 0,
					boxsize_inside_length: 0,
					boxsize_inside_width: 0,
					boxsize_inside_height: 0,
				}
			},
			{
				tag: "A4 Shallow",
				dimensions: {
					inside_inside_length: 0,
					inside_inside_width: 0,
					inside_inside_height: 0,
					boxsize_inside_length: 0,
					boxsize_inside_width: 0,
					boxsize_inside_height: 0,
				}
			},
			{
				tag: "A5 Deep",
				dimensions: {
					inside_inside_length: 0,
					inside_inside_width: 0,
					inside_inside_height: 0,
					boxsize_inside_length: 0,
					boxsize_inside_width: 0,
					boxsize_inside_height: 0,
				}
			},
			{
				tag: "A5 Shallow",
				dimensions: {
					inside_inside_length: 0,
					inside_inside_width: 0,
					inside_inside_height: 0,
					boxsize_inside_length: 0,
					boxsize_inside_width: 0,
					boxsize_inside_height: 0,
				}
			},
			{
				tag: "A6 Shallow",
				dimensions: {
					inside_inside_length: 0,
					inside_inside_width: 0,
					inside_inside_height: 0,
					boxsize_inside_length: 0,
					boxsize_inside_width: 0,
					boxsize_inside_height: 0,
				}
			},
			{
				tag: "Small",
				dimensions: {
					inside_inside_length: 0,
					inside_inside_width: 0,
					inside_inside_height: 0,
					boxsize_inside_length: 0,
					boxsize_inside_width: 0,
					boxsize_inside_height: 0,
				}
			},
			{
				tag: "Small Cube",
				dimensions: {
					inside_inside_length: 0,
					inside_inside_width: 0,
					inside_inside_height: 0,
					boxsize_inside_length: 0,
					boxsize_inside_width: 0,
					boxsize_inside_height: 0,
				}
			},
			{
				tag: "Medium",
				dimensions: {
					inside_inside_length: 0,
					inside_inside_width: 0,
					inside_inside_height: 0,
					boxsize_inside_length: 0,
					boxsize_inside_width: 0,
					boxsize_inside_height: 0,
				}
			},
			{
				tag: "Medium Lift Off Lid",
				dimensions: {
					inside_inside_length: 0,
					inside_inside_width: 0,
					inside_inside_height: 0,
					boxsize_inside_length: 0,
					boxsize_inside_width: 0,
					boxsize_inside_height: 0,
				}
			},
			{
				tag: "Large",
				dimensions: {
					inside_inside_length: 0,
					inside_inside_width: 0,
					inside_inside_height: 0,
					boxsize_inside_length: 0,
					boxsize_inside_width: 0,
					boxsize_inside_height: 0,
				}
			},
			{
				tag: "Large Cube",
				dimensions: {
					inside_inside_length: 0,
					inside_inside_width: 0,
					inside_inside_height: 0,
					boxsize_inside_length: 0,
					boxsize_inside_width: 0,
					boxsize_inside_height: 0,
				}
			},
			{
				tag: "XL Deep",
				dimensions: {
					inside_inside_length: 0,
					inside_inside_width: 0,
					inside_inside_height: 0,
					boxsize_inside_length: 0,
					boxsize_inside_width: 0,
					boxsize_inside_height: 0,
				}
			},
		],

		collections: {

			mailing_cartons: null

		}

	},

	api: {

	},

	init: function(){


	}

};

Shopify.Foldabox.init();

/*  ==============================
		1. Page-Specific Scripts
		============================== */

/*  ------------------------------
		1.1. Home Page
		------------------------------ */

	// turn grid collections into sliders
	$('.custom-collection-list .list-collections').find('.product_clear').remove()
	$('.custom-collection-list .list-collections .collection').each(function(){
		$(this).removeClass("alpha").removeClass("omega");
	})
	
	$('.custom-collection-list .list-collections').flickity({
		// options
		cellAlign: 'left',
		contain: true,
		pageDots: true
	});
		


/*  ------------------------------
		1.2. Collection Page
		------------------------------ */

		// Remove plural S in quantity label snippets on collection pages
		$(".collection .quantity-label__plural").remove();

		$(document).ready(function(){
			if ($(window).width() > 798) {
				$(".collection .sidebar-block h4.toggle").click();
			}
		});


/*  ------------------------------
		1.3. Product Page
		------------------------------ */
		// Remove plural S in quantity label snippets in recently viewed products
		$(".product-cross-sells .quantity-label__plural").remove();

/* ----- 1.3.1. Size Calculator ----- */

		var sizeCalculator = {

			storage: {

				conversion_factor: 0.393701

			},

			functions: {

				calculateMetric: function(){

					$(".sizes-calculator").find("[data-dimension]").each(function(){

						var dimension = $(this);
						var valueMetric = dimension.data("value");

						var value = valueMetric;

						var text = value + "cm";

						dimension.text(text);

					});

				},

				calculateImperial: function(){

					$(".sizes-calculator").find("[data-dimension]").each(function(){

						var dimension = $(this);
						var valueMetric = dimension.data("value");
						var valueImperial = sizeCalculator.functions.convertToInches(valueMetric);

						var value;

						var inchWholes = Math.floor(valueImperial);

						var inchFractions;
						inchFractions = valueImperial - inchWholes; // Isolating just the decimal
						inchFractions = Math.floor(inchFractions / 0.125) * 0.125; // Rounding the decimal to the eighth
						inchFractions = new Fraction(inchFractions); // Expressing decimal in fractions

						value = inchWholes + " " + "<span class='size__fraction'>" + inchFractions + "</span>";

						var text = value + "&#8243;";

						dimension.html(text);

					});

				},

				addEventListeners: function(){

					$(".toggle--imperial").on("click", sizeCalculator.eventHandler.clickImperial);
					$(".toggle--metric").on("click", sizeCalculator.eventHandler.clickMetric);

				},

				convertToInches: function(cm){

					var inches = cm * sizeCalculator.storage.conversion_factor;

					return inches;

				},

			},

			eventHandler: {

				clickImperial: function(){

					var button = $(event.currentTarget);

					if (button.hasClass("toggle--active")) {
						return;
					}

					// Show the appropriate size disclaimer in the calculator.
					$(".sizes-calculator .size-disclaimer .size-disclaimer__metric").addClass("hidden");
					$(".sizes-calculator .size-disclaimer .size-disclaimer__imperial").removeClass("hidden");

					// Remove the active state for the other link.
					$(".sizes-calculator .toggle").removeClass('toggle--active');

					// Add the active state for the clicked link.
					button.addClass("toggle--active");

					sizeCalculator.functions.calculateImperial();

				},

				clickMetric: function(event){

					var button = $(event.currentTarget);

					if (button.hasClass("toggle--active")) {
						return;
					}

					// Show the appropriate size disclaimer in the calculator.
					$(".sizes-calculator .size-disclaimer .size-disclaimer__metric").removeClass("hidden");
					$(".sizes-calculator .size-disclaimer .size-disclaimer__imperial").addClass("hidden");

					// Remove the active state for the other link.
					$(".sizes-calculator .toggle").removeClass('toggle--active');

					// Add the active state for the clicked link.
					button.addClass("toggle--active");

					sizeCalculator.functions.calculateMetric();

				}

			},

			init: function(){

				sizeCalculator.functions.addEventListeners();
				
				let activeSize = $(".toggle--active");
				
				if(activeSize.hasClass('toggle--metric')){
					sizeCalculator.functions.calculateMetric();
					$(".sizes-calculator .size-disclaimer .size-disclaimer__metric").removeClass("hidden");
					$(".sizes-calculator .size-disclaimer .size-disclaimer__imperial").addClass("hidden");
				}
				if(activeSize.hasClass('toggle--imperial')){
					sizeCalculator.functions.calculateImperial();
					$(".sizes-calculator .size-disclaimer .size-disclaimer__metric").addClass("hidden");
					$(".sizes-calculator .size-disclaimer .size-disclaimer__imperial").removeClass("hidden");
				}

			}

		};

/* ----- 1.3.2. Size Calculator ----- */

		if ( $("body").hasClass("product") || $("body").hasClass("collection") ) {
			sizeCalculator.init();
		}

/* ---------- 1.3.3. Sample labels  ----------- */

    // Don't display Sample labels on all thumbnails - only on the first one.
    if ( $("body").hasClass("product") ) {


      setTimeout(function() { 
        var sampleLabel = $('.badge--sample')[0];
        var newLabel = $('.badge--new')[0];
        var thumbnailCells = $('.gallery-cell');
        var tooltips = $('.tooltipstered');
        var flickityButtons = $('.flickity-button');

        $(tooltips).on("click", function() {
          var index = Array.prototype.indexOf.call(tooltips, this);
          if(index === 0) {
            $(sampleLabel).show();
            $(newLabel).show();
          } else {
            $(sampleLabel).hide();
            $(newLabel).hide();
          }
        });


        $(flickityButtons).on( "click", function() {
          if( $(thumbnailCells[0]).hasClass("is-selected") ) {
            $(sampleLabel).show();
            $(newLabel).show();
          } else {
            $(sampleLabel).hide();
            $(newLabel).hide();
          }
        });
      }, 1000);

    }


/* ---------- 1.3.4. Product Recommendations  ----------- */
    // Loads product recommendations in the product page.

    if ( $("body").hasClass("product") ) {
      var container = document.querySelector(".product-recommendations");

      function ProductRecommendations(containerElement) {
        var $container = (this.$container = $(containerElement));

        var baseUrl = $container.data('baseUrl');
        var productId = $container.data('productId');
        var limit = $container.data('limit');
        var intent = $container.data('intent');
        var intent = $container.data('intent');
        var sectionId = $container.data('sectionId');
        var productRecommendationsUrlAndContainerClass = baseUrl + '?section_id=' + sectionId + '&limit=' + limit +
          '&product_id=' + productId + '&intent='+ intent +
          ' .product-recommendations';
        $container.parent().load(productRecommendationsUrlAndContainerClass);
      }

      ProductRecommendations(container);
    }



/*  ------------------------------
		1.4. Blog Index
		------------------------------ */



/*  ------------------------------
		1.5. Blog Post
		------------------------------ */



/*  ------------------------------
		1.6. Cart Page
		------------------------------ */

/* ----- 1.6.1. VAT Validation ----- */

	


/* ----- 1.6.2. Swatch Cards ----- */

		Shopify.cartSwatchCards = {

			api: {

				addSwatchCard: function(data) {

					$.ajax({
						url: '/cart/add.js',
						type: 'post',
						dataType: 'json',
						data: data,
						success: function (data) {
							location.reload();
						}
					});

				}

			},

			functions: {

				addEventListeners: function() {

					$('[data-action~="AddSwatchCard"]').on("click", Shopify.cartSwatchCards.eventHandlers.onClickAdd);

				}

			},

			eventHandlers: {

				onClickAdd: function(event){

					var data = {
						quantity: 1,
						id: $(event.currentTarget).data("id")
					};

					Shopify.cartSwatchCards.api.addSwatchCard(data);

				}

			},

			reset: function(){

				if ( $("#swatch-card-addon").data("remove") == "remove" ) {

					var removeId = $("#swatch-card-addon").data("remove-id");

					var data = {
					  'id': removeId,
					  'quantity': 0
					};

					console.log(data);

					$.ajax({
						url: '/cart/change.js',
						type: 'post',
						dataType: 'json',
						data: data,
						async: false,
						success: function (data) {
							location.reload();
						}
					});

				}

				Shopify.cartSwatchCards.functions.addEventListeners();

			}

		};

/* ----- 1.6.3. EORI Number ----- */

	


/* ----- 1.6.4. Brexit Messaging ----- */

if ( $("body").hasClass("cart") === true ) {

	Shopify.cartSwatchCards.reset();

	

	

}

/*  ------------------------------
		1.7. Account
		------------------------------ */



/*  ==============================
		2. Components
		============================== */

/*  ------------------------------
		2.1. Tabs
		------------------------------ */

var tabs = { 

	functions: {

		addEventListeners: function(){

			$(".tabs .tab").on("click", tabs.eventHandlers.tabClick);
			$("#buy-in-bulk a").on("click", tabs.eventHandlers.buyInBulkLinkClick);
		},

		tabShow: function(tabCode){

			var tab = $(".tab[data-tab='" + tabCode + "']");
			var tabsContainer = tab.closest(".tabs");
			var tabs = tabsContainer.find(".tab");
			var tabContents = tabsContainer.find(".tab-content");
			var targetTabCode = tab.data("tab");
			var targetTabContent = $(".tab-content[data-tab='" + targetTabCode  + "']");

			tabs.removeClass("tab--active");
			tabContents.hide();

			tab.addClass("tab--active");
			targetTabContent.show();
			console.log("tabshow func")
		}

	},

	eventHandlers: {

		tabClick: function(event){

			var tab = $(event.currentTarget);
			var tabCode = tab.data("tab");

			if (tab.hasClass("tab--active")) {
				const mediaQuery = window.matchMedia('(max-width: 798px)')
				if (mediaQuery.matches) {
					tab.removeClass("tab--active");
					$(".tab-content").hide();
				}
				return;
			}

			tabs.functions.tabShow(tabCode);

		},

    buyInBulkLinkClick: function(event){
      tabs.functions.tabShow("page-volume-discounts");
    },
	},

	init: function() {

		tabs.functions.addEventListeners();

	}

};

tabs.init();

/*  ------------------------------
		2.2. Tooltips
		------------------------------ */

		var tooltips = {

			init: function(){
        $('.tooltip').tooltipster({
					theme: "tooltipster-borderless",
					side: "bottom"
				});
			}

		};

		tooltips.init();


/*  ==============================
		3. Utility Functions
		============================== */
		// Block right click on images
	/*	$(document).on('contextmenu', 'img', function(e){
		  return false;
		}); */

		// Read more button hide and shown
		var isOpen = $(".readmore-description").hasClass("readmore-description--open");
		$(".readmore-description__button").on("click", function(){
			if (isOpen) {
				$(".readmore-description").removeClass("readmore-description--open");
				$(".readmore-description").addClass("readmore-description--closed");
				isOpen = !isOpen;
			}
			else {
				$(".readmore-description").removeClass("readmore-description--closed");
				$(".readmore-description").addClass("readmore-description--open");
				isOpen = !isOpen;
			}
		});

/*  ==============================
		4. Plugins
		============================== */

		$(document).ready(function(){
			$(".scroll_button").smoothScroll();
		});

/*  ==============================
		5. Shipping Notification Banner
		============================== */
		
		$(document).ready(function(){
			$(".shipping_announcement_link").click(function(){
				$(".shipping_banner_title").slideUp('fast');
				$(".shipping_banner_copy").slideDown('fast');
			});
			$(".shipping_banner-close").click(function(){
				$(".shipping_banner_copy").slideUp('fast');
				$(".shipping_banner_title").slideDown('fast');
			});
		});
